'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;let

BaseFleetInsightSubViewController=function(_BaseController){_inherits(BaseFleetInsightSubViewController,_BaseController);
function BaseFleetInsightSubViewController($state,$scope,groupBasedDataService,uncaughtErrorHandler,groupTreeService){_classCallCheck(this,BaseFleetInsightSubViewController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this._$state=$state;
_this._$scope=$scope;
_this._groupBasedDataService=groupBasedDataService;

groupTreeService.linkController(_this);return _this;
}_createClass(BaseFleetInsightSubViewController,[{key:'groupTreeService',get:function()

{
return this._groupTreeService;
},set:function(

groupTreeService){
this._groupTreeService=groupTreeService;
}},{key:'$scope',get:function()

{
return this._$scope;
}},{key:'$state',get:function()

{
return this._$state;
}},{key:'stateName',get:function()

{
return'fdc.features.fleetInsight';
}},{key:'dataService',get:function()

{
return this._groupBasedDataService;
}},{key:'selectedGroupData',get:function()

{
return this._groupBasedDataService.selectedGroupData;
}}]);return BaseFleetInsightSubViewController}(BaseController);


module.exports=BaseFleetInsightSubViewController;
//# sourceMappingURL=baseFleetInsightSubViewController.js.map
